module.exports = __webpack_public_path__ + "static/media/cloud-check.50bb7379.svg";